import hotToast from 'react-hot-toast';

// While viewing as a customer the API client reports blocked writes (403 Read-only view) in the
// banner. Error toasts fired right after such a block are dropped so only the banner message shows.
const SUPPRESS_MS = 2000;
let blockedAt = 0;

export const markReadOnlyBlock = () => {
  blockedAt = Date.now();
};

const toast = Object.assign((...args) => hotToast(...args), hotToast, {
  error: (message, options) => {
    if (Date.now() - blockedAt < SUPPRESS_MS) return undefined;
    return hotToast.error(message, options);
  },
});

export default toast;
